module.exports = __webpack_public_path__ + "img/icon4.ed2d0d80.svg";